import { ref } from '@vue/composition-api';

export function useElementFocusing() {
  const element = ref<Element>();
  const isFocusing = ref(false);

  const onFocusin = () => (isFocusing.value = true);
  const onFocusout = () => (isFocusing.value = false);

  function setElement(ele: Element) {
    element.value = ele;
    element.value.addEventListener('focusin', onFocusin);
    element.value.addEventListener('focusout', onFocusout);
  }

  function clear() {
    if (element.value && element.value.removeEventListener) {
      element.value.removeEventListener('focusin', onFocusin);
      element.value.removeEventListener('focusout', onFocusout);
    }
  }

  return {
    isFocusing,
    setElement,
    clear,
  };
}
